import React, { useEffect, useState, useContext } from "react";
import { PropTypes } from "prop-types";
import { RadioGroup, Radio } from "@blueprintjs/core";
import { LangContext } from "../../LangContext";

BooleanField.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Field value
   */
  value: PropTypes.string,

  /**
   * Triggered when field value is changed
   */
  onValueChange: PropTypes.func,

  /**
   * Triggered when field validity is changed
   */
  onValidityChange: PropTypes.func,

  /**
   * Set as required. If field is set as required an value is NULL then field will be marked as invalid
   */
  required: PropTypes.bool,

  /**
   * Set to true to disable this field
   */
  disabled: PropTypes.bool
} : {};

function BooleanField(props, context) {
  var lang = useContext(LangContext);
  var value = props.value,
      onValueChange = props.onValueChange,
      required = props.required,
      disabled = props.disabled,
      readOnly = props.readOnly,
      onValidityChange = props.onValidityChange;

  var _useState = useState(true),
      valid = _useState[0],
      setValid = _useState[1];

  useEffect(function () {
    var invalidRequired = required && !value;

    var isValid = !invalidRequired;
    if (isValid != valid) {
      setValid(isValid);
      onValidityChange && onValidityChange(isValid);
    }
  }, [value, valid, required]);

  var handleChange = function handleChange(e) {
    var elementValue = e.target.value;

    onValueChange(elementValue || null);
  };

  return readOnly ? React.createElement(
    "span",
    { className: "dt-field-value dt-boolean-field--readOnly" },
    value == "t" ? lang.true : value == "f" || required ? lang.false : lang.notSet
  ) : React.createElement(
    RadioGroup,
    {
      onChange: handleChange,
      selectedValue: value || "",
      disabled: disabled,
      inline: true
    },
    React.createElement(Radio, { label: lang.true, value: "t" }),
    React.createElement(Radio, { label: lang.false, value: "f" }),
    !required && React.createElement(Radio, { label: lang.notSet, value: "" })
  );
}

export default BooleanField;